import { render, staticRenderFns } from "./UnauthorizedModal.vue?vue&type=template&id=a8a3bdf6&"
import script from "./UnauthorizedModal.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports